import React, { useState, useContext } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import {
  AppBar,
  Badge,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  Typography,
  makeStyles
} from '@material-ui/core';

import MenuIcon from '@material-ui/icons/Menu';
import HomeIcon from '@material-ui/icons/Home';
import InputIcon from '@material-ui/icons/Input';
import Logo from 'src/components/Logo';

import { Context } from '../../services/context';

const useStyles = makeStyles(() => ({
  root: {},
  avatar: {
    width: 60,
    height: 60
  }
}));

const TopBar = ({ onMobileNavOpen, ...rest }) => {

  const { handleLogout } = useContext(Context);
  const classes = useStyles();
  const [notifications] = useState([]);

  return (
    <AppBar
      className={classes.root}
      elevation={0}
      {...rest}
    >
      <Toolbar>
        <RouterLink to="/">
          <Logo />
        </RouterLink>
        <Box flexGrow={1}>
          <Typography
            color="inherit"
            variant="h4"
          > &nbsp;Sistema Integrado de Manutenção e Monitoramento
          </Typography>
        </Box>

        <Typography component="div" id="clock"></Typography>
        <Hidden mdDown>
          <IconButton color="inherit" href="/cfg/main">
            <Badge
              badgeContent={notifications.length}
              color="primary"
              variant="dot"
            >
              <HomeIcon />
            </Badge>
          </IconButton>
          <IconButton color="inherit" onClick={handleLogout} >
            <InputIcon />
          </IconButton>
        </Hidden>
        <Hidden lgUp>
          <IconButton
            color="inherit"
            onClick={onMobileNavOpen}
          >
            <MenuIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleLogout} >
            <InputIcon />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func
};

export default TopBar;
